import { FormattedMessage } from '@flipster/i18n';
import { Tooltip } from '@flipster/react/design-system-legacy/tooltip';
import InformationCircleIcon from '@flipster/react/icon/generated/InformationCircleIcon';
import { center, flex } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import { alert } from '@flipster/ui/Alert';

export const ConvertibleTooltip = () => {
  return (
    <div
      className={flex({
        justify: 'flex-start',
        align: 'center',
        textStyle: 'Legacy/Body2',
        gap: 6,
        mb: 6,
      })}
    >
      <FormattedMessage id='Convert.r250401.Convertible_balance' />
      <Tooltip
        placement='bottom'
        maxWidth={250}
        mobileAlert={() => {
          alert.show({
            title: <FormattedMessage id='Convert.r250401.Convertible_balance' />,
            message: <FormattedMessage id='Convert.r250401.Convertible_balance_tooltip_description' />,
            confirmText: <FormattedMessage id='Common.r250401.Confirm' />,
          });
        }}
      >
        <Tooltip.Trigger css={center.raw()}>
          <InformationCircleIcon size={18} color={token('colors.content.default.level-1')} />
        </Tooltip.Trigger>
        <Tooltip.Content>
          <FormattedMessage id='Convert.r250401.Convertible_balance_tooltip_description' />
        </Tooltip.Content>
      </Tooltip>
    </div>
  );
};
